import { Button, useLocalization } from '@magicdoorinc/ui';
import { createSignal, Show } from 'solid-js';
import IconRobotLight from '~/assets/images/identity/magic_person_lamplight.png';
import { useTrialStatus } from '~/contexts/global';
import { TrialPaymentMethodModal } from './TrialPaymentMethodModal';

const TrialBanner = () => {
  const { t } = useLocalization();
  const { shouldShowTrialBanner, daysUntilTrialExpires } = useTrialStatus();
  const [showPaymentModal, setShowPaymentModal] = createSignal(false);

  const handlePaymentSuccess = () => {
    setShowPaymentModal(false);
  };

  const handlePricingClick = () => {
    window.open('https://magicdoor.com/pricing', '_blank');
  };

  return (
    <Show when={shouldShowTrialBanner()}>
      <div class="border-primary-200 bg-primary-50 border-b px-3 py-2.5 md:px-4 md:py-3">
        <div class="flex flex-col items-start gap-3 md:flex-row md:items-center md:justify-between md:gap-0">
          <div class="flex w-full items-center md:w-auto">
            <div class="shrink-0">
              <img src={IconRobotLight} alt="Robot Light" class="mr-2 h-7 shrink-0 md:mx-2 md:h-8" />
            </div>
            <div class="flex-1">
              <p class="text-primary-800 break-words text-xs leading-relaxed md:text-sm">
                {t(
                  'Welcome! You have {days} days left in your trial. Ready to continue? Add a payment method to keep enjoying our features.',
                  { days: daysUntilTrialExpires() }
                )}
              </p>
            </div>
          </div>
          <div class="flex w-full items-center justify-end gap-2 md:w-auto md:shrink-0">
            <Button
              variant="text"
              onClick={handlePricingClick}
              class="min-w-[90px] px-2.5 py-1.5 text-xs font-medium capitalize md:min-w-0 md:px-3 md:text-sm">
              {t('View pricing')}
            </Button>
            <Button
              variant="outlined"
              onClick={() => setShowPaymentModal(true)}
              class="min-w-[100px] px-2.5 py-1.5 text-xs font-medium capitalize md:min-w-0 md:px-3 md:text-sm">
              {t('Add payment')}
            </Button>
          </div>
        </div>
      </div>

      <TrialPaymentMethodModal visible={showPaymentModal()} onClose={() => setShowPaymentModal(false)} onSuccess={handlePaymentSuccess} />
    </Show>
  );
};

export default TrialBanner;
